// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-eHG","colMin":"styles_colMin__3TjEn"};